import React, { useState } from "react";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { auth } from "../firebase/config";
import { useAuth } from "../contexts/AuthContext";
import { FREE_ACCESS_EMAILS } from "../utils/freeAccess";
import { Brand } from "./WorkspaceNavigation";
import SettingsButton from "./SettingsButton";

export const privilegedEmails: string[] = FREE_ACCESS_EMAILS;

export default function Login() {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser, enterGuestMode } = useAuth();
  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
      navigate("/");
    } catch (err: any) {
      setError(err.code === "auth/popup-closed-by-user" ? "The sign-in window was closed. You can try again or continue as a guest." : err.code === "auth/popup-blocked" ? "Your browser blocked the sign-in window. Allow pop-ups for this site and try again." : "We couldn’t sign you in. Check your connection and try again.");
    } finally { setLoading(false); }
  };
  if (currentUser) return <Navigate to="/" replace />;
  return (
    <main className="login-page login-simple">
      <section className="login-entry" aria-label="Sign in">
        <div className="login-entry-content">
          <Brand />
          <h1>Sign in</h1>
          {error && <div role="alert" className="login-error">{error}</div>}
          <button type="button" disabled={loading} onClick={handleGoogleLogin} className="login-google">{loading ? <Loader2 size={19} className="animate-spin" /> : <svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" /><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" /><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" /><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" /></svg>}{loading ? "Opening sign-in…" : "Continue with Google"}<ArrowRight size={16} /></button>
          <div className="login-divider"><span>or</span></div>
          <button type="button" disabled={loading} onClick={() => { enterGuestMode(); navigate("/"); }} className="button-secondary w-full">Continue without signing in <ArrowRight size={16} /></button>
          <p className="login-guest-note">Guest conversations aren’t saved.</p>
          <div className="login-settings"><SettingsButton /></div>
        </div>
      </section>
    </main>
  );
}
